import React from 'react'
import * as d3 from 'd3'
import SVG from 'react-svg'
import './styles.scss'
export interface Props {}

const data = require('../mietmaps_d3 - map_basel.csv')
const radMinMax = [0, 18]

export const LineMap = ({  }: Props) => {
  const draw = svgEL => {
    const max = d3.max(data, d => {
      return +d.Mietpreis
    })
    const min = d3.min(data, d => {
      return +d.Mietpreis
    })
    const minMax = d3.extent(data, d => {
      return +d.Mietpreis
    })

    var rad = d3
      .scaleSqrt()
      .domain([1100, max])
      .range(radMinMax)
    var svg = d3
      .select(svgEL)
      .attr('class', 'lineMapSVG')
     

    data.forEach(stop => {
      if (stop.ID && stop.ID !== '') {
        var s = svg.select('#' + stop.ID)
        if (!s.empty()) {
          s.attr('class', 'dataCircle')
            .transition()
            .attr('r', rad(stop.Mietpreis))
        }
      }
    })
  }

  return (
    <>
      <div className='svg-flex'>
        <div className='svg-flex-inner'>
          <SVG
            src={require('images/karte-tramlinien.svg')}
            afterInjection={(error, svg) => {
              if (error) {
                console.error(error)
                return
              }
              draw(svg)
            }}
          />
        </div>
      </div>
    </>
  )
}
